"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var utils_2 = require("./utils");
var hub_metrify_event_1 = __importDefault(require("./models/hub-metrify-event"));
var hub_metrify_1 = __importDefault(require("./models/hub-metrify"));
var hub_1 = __importDefault(require("./models/hub"));
var service_1 = __importDefault(require("./service"));
var EventAgent = /** @class */ (function () {
    function EventAgent() {
        this.mode = 'staging';
    }
    // TODO: deprecated
    EventAgent.prototype.get = function (params) {
        if (params === void 0) { params = {}; }
        return service_1.default.get(params, this.mode);
    };
    EventAgent.prototype.send = function (hubData) {
        if (!hubData || typeof hubData !== 'object') {
            var errorMessage = 'eventHub instance is required';
            console.error(errorMessage);
            return Promise.reject(errorMessage);
        }
        var _a = (0, utils_2.validateRequiredFields)(hubData, ['system', 'entity', 'action', 'event']), isValid = _a.isValid, invalidField = _a.invalidField;
        if (!isValid) {
            var errorMessage = "parameter ".concat(invalidField, " is required");
            console.error(errorMessage);
            return Promise.reject(errorMessage);
        }
        var eventHub = new hub_1.default({
            system: hubData.system,
            entity: hubData.entity,
            action: hubData.action,
            data_version: hubData.data_version || '1.0',
            event: hubData.event
        });
        return service_1.default.send(eventHub, this.mode);
    };
    EventAgent.prototype.sendMetrify = function (hubData, element) {
        if (!hubData || typeof hubData !== 'object') {
            var errorMessage = 'eventHub instance is required';
            console.error(errorMessage);
            return Promise.reject(errorMessage);
        }
        var validationEventHub = (0, utils_2.validateRequiredFields)(hubData, ['system', 'event']);
        if (!validationEventHub.isValid) {
            var errorMessage = "parameter ".concat(validationEventHub.invalidField, " is required");
            console.error(errorMessage);
            return Promise.reject(errorMessage);
        }
        var validationEvent = (0, utils_2.validateRequiredFields)(hubData.event, ['group', 'name']);
        if (!validationEvent.isValid) {
            var errorMessage = "parameter ".concat(validationEvent.invalidField, " is required inside event");
            console.error(errorMessage);
            return Promise.reject(errorMessage);
        }
        var eventHubMetrify = new hub_metrify_1.default({
            system: hubData.system,
            event: new hub_metrify_event_1.default(hubData.event)
        });
        if (element && (0, utils_1.isElement)(element)) {
            eventHubMetrify.event.element = { tag_name: element.tagName };
            for (var i = 0; i < element.attributes.length; i++) {
                var attribute = element.attributes[i];
                eventHubMetrify.event.element[attribute.nodeName] = attribute.nodeValue;
            }
        }
        return service_1.default.sendMetrify(eventHubMetrify, this.mode);
    };
    return EventAgent;
}());
exports.default = new EventAgent();
